export function getLabels(ml = false) {
  return {
    appTitle: ml ? 'എൻഎംഹെൽപ്പർ' : 'NMhelper',
    selectRole: ml ? 'റോൾ തിരഞ്ഞെടുക്കുക' : 'Select role',
    admin: ml ? 'അഡ്മിൻ' : 'Admin',
    head: ml ? 'പ്രധാനാധ്യാപകൻ' : 'Head',
    teacher: ml ? 'അദ്ധ്യാപകൻ' : 'Teacher',
    username: ml ? 'ഉപയോക്തൃനാമം' : 'Username',
    loginSuffix: ml ? 'പെൻ / ക്ലാസ് ID' : 'Pen or class ID',
    loginSuffixPlaceholder: ml ? 'ഉദാ. 12 അല്ലെങ്കിൽ 2A' : 'e.g. 12 or 2A',
    loginSuffixHint: ml
      ? 'പെൻ നമ്പർ അല്ലെങ്കിൽ ക്ലാസ് പേര് (ദിവസം വേതന അദ്ധ്യാപകർക്ക് ക്ലാസ് പേര്). സ്കൂൾ കോഡ് മാറ്റാനാവില്ല.'
      : 'Pen number or class name (daily wage: use class name). School code is fixed.',
    loginIdPreview: ml ? 'ലോഗിൻ ID' : 'Login ID',
    teacherLoginHint: ml
      ? 'പൂർണ്ണ ലോഗിൻ ID ഉപയോഗിക്കുക (ഉദാ. head1_2A — സ്കൂൾ കോഡ് + പെൻ/ക്ലാസ്)'
      : 'Use your full login ID (e.g. head1_2A — school code + pen or class)',
    loginNetworkError: ml
      ? 'സെർവറിലേക്ക് കണക്ട് ചെയ്യാനാവുന്നില്ല (നെറ്റ്‌വർക്ക് പിശക്). ഇന്റർനെറ്റ് / മൊബൈൽ ഡാറ്റ പരീക്ഷിക്കുക. തുടർന്നും പരാജയപ്പെട്ടാൽ Copy report അയയ്ക്കുക.'
      : 'Cannot reach the server (network error). Check internet or try mobile data. If it keeps failing, Copy report and send to support.',
    loginWrongRoleHint: ml
      ? 'ഈ യൂസർനാമം {role} അക്കൗണ്ടാണ്. {role} തിരഞ്ഞെടുത്ത് വീണ്ടും ശ്രമിക്കുക.'
      : 'This username belongs to {role}. Select {role} and try again.',
    loginBadPasswordHint: ml
      ? 'യൂസർനാമം ശരിയാണ്; പാസ്‌വേഡ് തെറ്റാണ്. സ്കൂൾ ഹെഡിനോട് പാസ്‌വേഡ് റീസെറ്റ് ചോദിക്കുക.'
      : 'Username found, but password is wrong. Ask your school head to reset the teacher password.',
    loginUserNotFound: ml
      ? 'യൂസർനാമം കണ്ടെത്തിയില്ല. സ്പെല്ലിംഗും റോളും പരിശോധിക്കുക.'
      : 'Username not found. Check spelling and role.',
    loginTeacherIdFormatHint: ml
      ? 'അദ്ധ്യാപക ലോഗിന് പൂർണ്ണ ID വേണം (ഉദാ. schoolcode_2A).'
      : 'Teacher login needs full ID like schoolcode_2A (school code + _ + class/pen).',
    loginHeadNotTeacherIdHint: ml
      ? 'ഇത് അദ്ധ്യാപക ID പോലെ തോന്നുന്നു. Teacher തിരഞ്ഞെടുക്കുക, അല്ലെങ്കിൽ ഹെഡ് യൂസർനാമം ഉപയോഗിക്കുക.'
      : 'That looks like a teacher ID. Select Teacher, or use the head username without _class.',
    loginReportHint: ml
      ? 'ഒരു ടാപ്പിൽ റോൾ, യൂസർനാമം, പിശക്, ആപ്പ് വേർഷൻ, ഡിവൈസ് വിവരം അയയ്ക്കാം. പാസ്‌വേഡ് ഉൾപ്പെടുത്തില്ല.'
      : 'One tap sends role, username, error, app version, and device info. Password is never included.',
    loginReportHintShort: ml
      ? 'സഹായം വേണോ? റിപ്പോർട്ട് അയയ്ക്കുക (പാസ്‌വേഡ് ഇല്ല).'
      : 'Need help? Send a report (password not included).',
    loginReportCopy: ml ? 'പൂർണ്ണ റിപ്പോർട്ട് കോപ്പി' : 'Copy full report',
    loginReportCopyShort: ml ? 'കോപ്പി' : 'Copy',
    loginReportCopied: ml ? 'കോപ്പി ചെയ്തു — ഒട്ടിക്കുക' : 'Copied — paste anywhere',
    loginReportCopiedShort: ml ? 'കോപ്പി ചെയ്തു' : 'Copied',
    loginErrorTitle: ml ? 'സൈൻ ഇൻ പരാജയപ്പെട്ടു' : 'Sign-in failed',
    loginReportTitle: ml ? 'സപ്പോർട്ടിന് പിശക് റിപ്പോർട്ട് അയയ്ക്കുക' : 'Send error report to support',
    loginReportWhatsApp: ml ? 'വാട്സ്ആപ്പിൽ അയയ്ക്കുക' : 'Send on WhatsApp',
    loginReportWhatsAppShort: ml ? 'വാട്സ്ആപ്പ്' : 'WhatsApp',
    loginReportEmail: ml ? 'ഇമെയിൽ' : 'Email',
    loginReportShare: ml ? 'ഷെയർ' : 'Share',
    loginReportShow: ml ? 'റിപ്പോർട്ട് വിശദാംശങ്ങൾ' : 'Show report details',
    loginReportHide: ml ? 'മറയ്ക്കുക' : 'Hide details',
    loginReportCopyFailed: ml
      ? 'കോപ്പി പരാജയപ്പെട്ടു — വിശദാംശങ്ങൾ തുറന്ന് ലോംഗ് പ്രസ് ചെയ്യുക.'
      : 'Copy failed — open details and long-press to select.',
    loginReportReach: ml
      ? 'വാട്സ്ആപ്പ് {wa} · ഇമെയിൽ {email}'
      : 'WhatsApp {wa} · Email {email}',
    loginReportFab: ml ? 'റിപ്പോർട്ട് അയയ്ക്കുക' : 'Send report',
    loginReportFabHint: ml ? 'ലോഗിൻ പിശക് റിപ്പോർട്ട് അയയ്ക്കുക' : 'Send your login error report',
    schoolCodeHint: ml
      ? 'അദ്ധ്യാപകർ {code}_പെൻ അല്ലെങ്കിൽ {code}_2A എന്ന് ലോഗിൻ ചെയ്യും'
      : 'Teachers will log in as {code}_pen or {code}_2A',
    password: ml ? 'പാസ്‌വേഡ്' : 'Password',
    login: ml ? 'സൈൻ ഇൻ' : 'Sign in',
    contactNeedHelp: ml ? 'സഹായം വേണോ?' : 'Need help?',
    contactSupport: ml ? 'സഹായത്തിന് ബന്ധപ്പെടുക' : 'Contact support',
    contactChoose: ml ? 'എങ്ങനെ ബന്ധപ്പെടണം എന്ന് തിരഞ്ഞെടുക്കുക' : 'Choose how to reach us',
    contactEmail: ml ? 'ഇമെയിൽ' : 'Email',
    contactWhatsApp: ml ? 'വാട്സ്ആപ്പ്' : 'WhatsApp',
    contactWhatsAppHint: ml ? 'ചാറ്റ് ആരംഭിക്കുക' : 'Start a chat',
    signOut: ml ? 'പുറത്ത്' : 'Sign out',
    navHome: ml ? 'ഹോം' : 'Home',
    navSwitchClass: ml ? 'ക്ലാസ്' : 'Class',
    navMore: ml ? 'കൂടുതൽ' : 'More',
    navReport: ml ? 'റിപ്പോർട്ട്' : 'Report',
    navClasses: ml ? 'ക്ലാസ്' : 'Classes',
    navTeachers: ml ? 'അധ്യാപകർ' : 'Teachers',
    navHistory: ml ? 'ചരിത്രം' : 'History',
    navSchools: ml ? 'സ്കൂൾ' : 'Schools',
    navTesters: ml ? 'ടെസ്റ്റേഴ്സ്' : 'Testers',
    navSettings: ml ? 'ക്രമീകരണം' : 'Settings',
    navAccount: ml ? 'അക്കൗണ്ട്' : 'Account',
    boys: ml ? 'ആൺകുട്ടികൾ' : 'Boys',
    girls: ml ? 'പെൺകുട്ടികൾ' : 'Girls',
    updateStrength: ml ? 'NM ഹാജർ സേവ്' : 'Save NM present',
    reportTitle: ml ? 'ഇന്നത്തെ റിപ്പോർട്ട്' : "Today's report",
    reportViewByDivision: ml ? 'വിഭാഗം പ്രകാരം' : 'By division',
    reportTodayConsolidated: ml ? 'ദിവസം സംഗ്രഹം' : 'Day consolidation',
    refresh: ml ? 'റിഫ്രഷ്' : 'Refresh',
    export: ml ? 'എക്സ്പോർട്ട്' : 'Export',
    nutritionExportAll: ml ? 'എല്ലാം എക്സ്പോർട്ട്' : 'Export all',
    nutritionItemColumn: ml ? 'ഇനം' : 'Item',
    exportODS: ml ? 'ODS' : 'ODS',
    exportCSV: ml ? 'CSV' : 'CSV',
    exportDOC: ml ? 'DOC' : 'DOC',
    exportPDF: ml ? 'PDF' : 'PDF',
    toggleLang: ml ? 'English' : 'മലയാളം',

    pwaInstallTitle: ml ? 'NMhelper ഇൻസ്റ്റാൾ ചെയ്യൂ' : 'Install NMhelper',
    pwaInstallSubtitle: ml
      ? 'മികച്ച അനുഭവത്തിന് ഹോം സ്ക്രീനിലേക്ക് ചേർക്കുക'
      : 'Add to your home screen for the best experience',
    pwaBenefitFast: ml
      ? 'ഒരു ടാപ്പിൽ വേഗത്തിൽ തുറക്കാം — ബ്രൗസർ ബാർ ഇല്ല'
      : 'Opens in one tap — no browser bar',
    pwaBenefitOffline: ml
      ? 'ഓഫ്‌ലൈൻ ആയും പ്രവർത്തിക്കും; വീണ്ടും ഓൺലൈൻ ആകുമ്പോൾ സ്വയം സിങ്ക് ചെയ്യും'
      : 'Works offline and syncs automatically when you reconnect',
    pwaBenefitHome: ml
      ? 'ഫോണിലെയും ലാപ്ടോപ്പിലെയും ഹോം സ്‌ക്രീനിൽ പ്രത്യേക ഐക്കൺ'
      : 'Its own icon on your phone or laptop home screen',
    pwaInstall: ml ? 'ഇൻസ്റ്റാൾ' : 'Install',
    pwaInstallHowto: ml ? 'എങ്ങനെ ഇൻസ്റ്റാൾ ചെയ്യാം' : 'How to install',
    pwaSkip: ml ? 'വേണ്ട' : 'Not now',
    pwaRemindLater: ml ? 'നാളെ വീണ്ടും ഓർമിപ്പിക്കുക' : 'Remind me tomorrow',
    pwaGotIt: ml ? 'മനസ്സിലായി' : 'Got it',
    pwaIosHint: ml
      ? 'iOS Safari-ൽ: താഴത്തെ Share ബട്ടൺ അമർത്തുക → "Add to Home Screen" തിരഞ്ഞെടുക്കുക.'
      : 'On iOS Safari: tap the Share button below, then choose "Add to Home Screen".',
    division: ml ? 'ഡിവിഷൻ' : 'Division',
    classNumber: ml ? 'ക്ലാസ്' : 'Class',
    selectClassNumber: ml ? 'ക്ലാസ് തിരഞ്ഞെടുക്കുക' : 'Select class',
    classDivision: ml ? 'ഡിവിഷൻ' : 'Division',
    classDivisionPlaceholder: ml ? 'ഉദാ. A, B, AA, A1' : 'e.g. A, B, AA, A1',
    classNamePreview: ml ? 'ക്ലാസ് പേര്' : 'Class name',
    classMaxBoys: ml ? 'പരമാവധി ആൺകുട്ടികൾ' : 'Max boys',
    classMaxGirls: ml ? 'പരമാവധി പെൺകുട്ടികൾ' : 'Max girls',
    classCapsHint: ml
      ? 'അദ്ധ്യാപകൻ ഓരോ കോളത്തിലും ഈ എണ്ണത്തിൽ കൂടുതൽ നൽകാൻ കഴിയില്ല'
      : 'Teachers cannot enter more than these limits in each column',
    classStudentsTotal: ml ? 'ക്ലാസിലെ ആകെ വിദ്യാർത്ഥികൾ' : 'Students recorded',
    classCapacityTotal: ml ? 'പരമാവധി ആകെ' : 'Capacity total',
    date: ml ? 'തീയതി' : 'Date',
    maxStudents: ml ? 'പരമാവധി' : 'Max students',
    maxBoys: ml ? 'പരമാവധി ആൺ' : 'Max boys',
    maxGirls: ml ? 'പരമാവധി പെൺ' : 'Max girls',
    classCapsLine: ml ? 'പരമാവധി' : 'Limits',
    totalStudents: ml ? 'ആകെ' : 'Total',
    actions: ml ? 'പ്രവർത്തനങ്ങൾ' : 'Actions',
    name: ml ? 'പേര്' : 'Name',
    status: ml ? 'നില' : 'Status',
    updated: ml ? 'അപ്‌ഡേറ്റ് ചെയ്തു' : 'Updated',
    notUpdated: ml ? 'അപ്‌ഡേറ്റ് ചെയ്തിട്ടില്ല' : 'Not updated',
    delete: ml ? 'ഇല്ലാതാക്കുക' : 'Delete',
    editMax: ml ? 'പരമാവധി എഡിറ്റ്' : 'Edit limits',
    editMaxTitle: ml ? 'ആൺ / പെൺ പരമാവധി' : 'Edit boys & girls limits',
    editMaxHint: ml
      ? 'ഓരോ കോളത്തിനും പരമാവധി എണ്ണം. അദ്ധ്യാപകൻ ഇതിൽ കൂടുതൽ നൽകാൻ കഴിയില്ല.'
      : 'Maximum allowed in each column. Teachers cannot save more than these.',
    editMaxPlaceholder: ml ? 'ഉദാ. 40' : 'e.g. 40',
    addClass: ml ? 'ക്ലാസ് ചേർക്കുക' : 'Add class',
    addTeacher: ml ? 'അദ്ധ്യാപകനെ ചേർക്കുക' : 'Add teacher',
    selectClass: ml ? 'ക്ലാസ് തിരഞ്ഞെടുക്കുക' : 'Select class',
    selectUnassignedClass: ml ? 'അനിയോഗിത ക്ലാസ്' : 'Unassigned class only',
    noUnassignedClasses: ml
      ? 'എല്ലാ ക്ലാസുകളിലും അദ്ധ്യാപകൻ ഉണ്ട്. പുതിയ ക്ലാസ് ചേർക്കുക അല്ലെങ്കിൽ നിലവിലെ അദ്ധ്യാപകനെ ഇല്ലാതാക്കുക.'
      : 'All classes already have a teacher. Add a new class or remove a teacher first.',
    teacherClass: ml ? 'ക്ലാസ്' : 'Class',
    notAssignedToClass: ml ? 'ക്ലാസ് ഇല്ല' : 'No class assigned',
    classesTitle: ml ? 'ക്ലാസുകൾ' : 'Classes',
    teachersTitle: ml ? 'അദ്ധ്യാപകർ' : 'Teachers',
    historicalReportsTitle: ml ? 'ചരിത്രം' : 'History',
    reportModeDay: ml ? 'ദിവസം' : 'Day',
    reportModeDayConsolidated: ml ? 'ദിവസം സംഗ്രഹം' : 'Day consolidation',
    reportModeMonth: ml ? 'മാസം' : 'Month',
    selectMonth: ml ? 'മാസം തിരഞ്ഞെടുക്കുക' : 'Select month',
    viewReport: ml ? 'കാണുക' : 'View',
    grandTotal: ml ? 'ആകെ' : 'Grand total',
    rowTotal: ml ? 'ആകെ' : 'Total',
    noMonthlyData: ml ? 'ഈ മാസത്തിൽ റെക്കോർഡ് ഇല്ല' : 'No recordings this month',
    toastExportDone: ml ? 'എക്സ്പോർട്ട് സേവ് ചെയ്തു' : 'Export saved',
    selectDatePrompt: ml ? 'തീയതി തിരഞ്ഞെടുക്കുക' : 'Select date',
    myClass: ml ? 'എന്റെ ക്ലാസ്' : 'My class',
    adminDashboard: ml ? 'അഡ്മിൻ' : 'Admin',
    addSchoolHead: ml ? 'ഹെഡ് ചേർക്കുക' : 'Add school head',
    schoolHeads: ml ? 'സ്കൂൾ ഹെഡ്സ്' : 'School heads',
    cancel: ml ? 'റദ്ദാക്കുക' : 'Cancel',
    addHead: ml ? 'ചേർക്കുക' : 'Add',
    setDivisionsTitle: ml ? 'ഡിവിഷനുകൾ സജ്ജമാക്കുക' : 'Set divisions',
    setDivisionsHint: ml ? 'ഉപയോക്തൃനാമം ഉപയോഗിച്ച് ഡിവിഷനുകൾ അപ്‌ഡേറ്റ് ചെയ്യുക' : 'Update divisions by head username',
    editDivisions: ml ? 'ഡിവിഷനുകൾ എഡിറ്റ് ചെയ്യുക' : 'Edit divisions',
    headUsernameLabel: ml ? 'ഹെഡ് ഉപയോക്തൃനാമം' : 'Head username',
    numDivisionsLabel: ml ? 'ഡിവിഷനുകളുടെ എണ്ണം' : 'Number of divisions',
    setDivisionsBtn: ml ? 'സേവ്' : 'Save',
    account: ml ? 'അക്കൗണ്ട്' : 'Account',
    home: ml ? 'ഹോം' : 'Home',
    schools: ml ? 'സ്കൂളുകൾ' : 'Schools',
    settings: ml ? 'സെറ്റിംഗ്സ്' : 'Settings',
    settingsTitle: ml ? 'അഡ്മിൻ ഓവർവ്യൂ' : 'Admin overview',
    settingsSubtitle: ml
      ? 'സ്കൂൾ ഹെഡ്സ് ടാബിൽ ഡിവിഷനുകൾ ചേർക്കുകയും എഡിറ്റ് ചെയ്യുകയും ചെയ്യാം'
      : 'Add and edit divisions on the Schools tab',
    totalDivisionsCap: ml ? 'ആകെ ഡിവിഷൻ ലിമിറ്റ്' : 'Total division slots',
    totalDivisionsCapHint: ml ? 'എല്ലാ ഹെഡ്സിന്റെയും കൂട്ടം' : 'Sum across all heads',
    systemStatusTitle: ml ? 'സിസ്റ്റം നില' : 'System status',
    apiConnection: ml ? 'API കണക്ഷൻ' : 'API connection',
    apiOnline: ml ? 'ഓൺലൈൻ' : 'Online',
    apiOffline: ml ? 'ഓഫ്‌ലൈൻ' : 'Offline',
    refreshSchoolHeads: ml ? 'ഹെഡ് ലിസ്റ്റ് റിഫ്രഷ്' : 'Refresh school heads list',
    preferencesTitle: ml ? 'മുൻഗണനകൾ' : 'Preferences',
    appLanguage: ml ? 'ഭാഷ' : 'Language',
    appLanguageHint: ml ? 'ആപ്പ് ലേബലുകൾക്ക്' : 'For app labels',
    howItWorksTitle: ml ? 'എങ്ങനെ പ്രവർത്തിക്കും' : 'How it works',
    howItWorksAdmin: ml
      ? 'അഡ്മിൻ: സ്കൂൾ ഹെഡ്സ് ചേർക്കുക, ഡിവിഷൻ എണ്ണം നൽകുക, താൽക്കാലികം നിർത്തുക.'
      : 'Admin: add school heads, set division limits, pause or remove heads.',
    howItWorksHead: ml
      ? 'ഹെഡ്: ക്ലാസുകൾ, അദ്ധ്യാപകർ, റിപ്പോർട്ട്, ചരിത്രം നിയന്ത്രിക്കുന്നു.'
      : 'Head: manages classes, teachers, daily reports, and history.',
    howItWorksTeacher: ml
      ? 'അദ്ധ്യാപകൻ: ദൈനംദിന ആൺ/പെൺ എണ്ണം നൽകുന്നു (ഓഫ്‌ലൈൻ സപ്പോർട്ട്).'
      : 'Teacher: enters daily boys/girls counts (works offline).',
    resourcesTitle: ml ? 'ലിങ്കുകൾ' : 'Links',
    websiteLink: ml ? 'NMhelper വെബ്സൈറ്റ്' : 'NMhelper website',
    privacyLink: ml ? 'സ്വകാര്യതാ നയം' : 'Privacy policy',
    termsLink: ml ? 'നിബന്ധനകളും വ്യവസ്ഥകളും' : 'Terms & conditions',
    loginTermsNotice: ml
      ? 'സൈൻ ഇൻ ചെയ്യുന്നതിലൂടെ നിങ്ങൾ ഞങ്ങളുടെ നിബന്ധനകളും സ്വകാര്യതാ നയവും അംഗീകരിക്കുന്നു.'
      : 'By signing in, you agree to our Terms & conditions and Privacy policy.',
    deleteDataLink: ml ? 'ഡാറ്റ ഇല്ലാതാക്കാൻ അഭ്യർത്ഥിക്കുക' : 'Request data deletion',
    deleteDataHint: ml
      ? 'അക്കൗണ്ടും സ്കൂൾ ഡാറ്റയും സെർവറിൽ നിന്ന് നീക്കം ചെയ്യുക'
      : 'Remove your account and school data from our servers',
    helpLink: ml ? 'ഉപയോഗ ഗൈഡ്' : 'User guide',
    helpLinkHint: ml ? 'ഹെഡ് & അദ്ധ്യാപകൻ സഹായം' : 'Head & teacher help',
    helpPdfDownload: ml ? 'ഗൈഡ് PDF ഡൗൺലോഡ്' : 'Download guide (PDF)',
    helpPdfDownloadHint: ml ? 'ഓഫ്‌ലൈനിൽ വായിക്കാൻ NMHelper.pdf' : 'NMHelper.pdf — save for offline reading',
    report: ml ? 'റിപ്പോർട്ട്' : 'Report',
    history: ml ? 'ചരിത്രം' : 'History',
    paused: ml ? 'നിർത്തി' : 'Paused',
    active: ml ? 'സജീവം' : 'Active',
    pause: ml ? 'നിർത്തുക' : 'Pause',
    resume: ml ? 'തുടരുക' : 'Resume',
    noData: ml ? 'ഡാറ്റയില്ല' : 'No data yet',
    loading: ml ? 'ലോഡ് ചെയ്യുന്നു...' : 'Loading...',
    changePassword: ml ? 'പാസ്‌വേഡ് മാറ്റുക' : 'Change password',
    editTeacherName: ml ? 'പേര് മാറ്റുക' : 'Edit name',
    editTeacherNameTitle: ml ? 'അദ്ധ്യാപകന്റെ പേര് മാറ്റുക' : 'Edit teacher name',
    editTeacherNameHint: ml
      ? 'ലോഗിൻ username (@ക്ലാസ് ID) അതേപടി തുടരും. പുതിയ അദ്ധ്യാപകന്റെ പേര് മാത്രം മാറ്റുക.'
      : 'Login username (@class ID) stays the same. Change only the teacher display name.',
    headRecordStrength: ml ? 'NM ഹാജർ നൽകുക' : 'Record NM present',
    headRecordStrengthTitle: ml ? 'ഇന്നത്തെ NM ഹാജർ' : "Record today's NM present",
    headRecordStrengthHint: ml
      ? 'അദ്ധ്യാപകൻ ഇല്ലാത്തപ്പോൾ ഹെഡ് നൽകാം. ഇന്നത്തെ NM ഹാജർ (ആൺ/പെൺ) സേവ് ചെയ്യും.'
      : 'For when the teacher is absent. Saves today\'s NM present — boys and girls counts.',
    toastTeacherNameUpdated: ml ? 'അദ്ധ്യാപകന്റെ പേര് മാറ്റി' : 'Teacher name updated',
    resetPassword: ml ? 'പാസ്‌വേഡ് റീസെറ്റ്' : 'Reset password',
    resetPasswordTitleTeacher: ml ? 'അദ്ധ്യാപകന്റെ പാസ്‌വേഡ് റീസെറ്റ്' : 'Reset teacher password',
    resetPasswordTitleHead: ml ? 'ഹെഡിന്റെ പാസ്‌വേഡ് റീസെറ്റ്' : 'Reset head password',
    resetPasswordHint: ml
      ? 'പുതിയ പാസ്‌വേഡ് അദ്ധ്യാപകനെ/ഹെഡിനെ അറിയിക്കുക. കുറഞ്ഞത് 5 അക്ഷരങ്ങൾ.'
      : 'Tell them the new password in person. At least 5 characters.',
    resetPasswordSave: ml ? 'പാസ്‌വേഡ് സേവ്' : 'Save new password',
    resetPasswordFillAll: ml ? 'എല്ലാ ഫീൽഡുകളും പൂരിപ്പിക്കുക' : 'Please fill all fields',
    resetPasswordMismatch: ml ? 'പാസ്‌വേഡുകൾ പൊരുത്തപ്പെടുന്നില്ല' : 'Passwords do not match',
    resetPasswordTooShort: ml ? 'കുറഞ്ഞത് 5 അക്ഷരങ്ങൾ' : 'At least 5 characters',
    newPassword: ml ? 'പുതിയ പാസ്‌വേഡ്' : 'New password',
    confirmPassword: ml ? 'പാസ്‌വേഡ് സ്ഥിരീകരിക്കുക' : 'Confirm password',
    toastTeacherPasswordReset: ml ? 'അദ്ധ്യാപകന്റെ പാസ്‌വേഡ് റീസെറ്റ് ചെയ്തു' : 'Teacher password reset',
    toastHeadPasswordReset: ml ? 'ഹെഡിന്റെ പാസ്‌വേഡ് റീസെറ്റ് ചെയ്തു' : 'Head password reset',
    offlineSaved: ml ? 'ഓഫ്‌ലൈനിൽ സേവ് ചെയ്തു' : 'Saved offline',
    pendingSync: ml ? 'സമന്വയിക്കാൻ കാത്തിരിക്കുന്നു' : 'Pending sync',
    syncNow: ml ? 'ഇപ്പോൾ സമന്വയിക്കുക' : 'Sync now',
    toastSyncComplete: ml ? 'ഓഫ്‌ലൈൻ മാറ്റങ്ങൾ സമന്വയിച്ചു' : 'Offline changes synced',
    toastSyncFailed: ml
      ? 'സമന്വയം പൂർത്തിയാക്കാനായില്ല. “ഇപ്പോൾ സമന്വയിക്കുക” ടാപ്പ് ചെയ്യുക.'
      : 'Could not finish sync. Tap Sync now to retry.',
    toastSyncPartial: ml
      ? 'ചില മാറ്റങ്ങൾ സമന്വയിച്ചില്ല. വീണ്ടും ശ്രമിക്കുക.'
      : 'Some changes did not sync. Try again.',
    loginCreditBy: ml ? 'നിർമ്മിച്ചത്' : 'Created by',
    assignTeacher: ml ? 'അദ്ധ്യാപകനെ നിയോഗിക്കുക' : 'Assign teacher',
    strengthStatus: ml ? 'അപ്‌ഡേറ്റ് നില' : 'Update status',
    hideStrengthStatus: ml ? 'നില മറയ്ക്കുക' : 'Hide status',
    strengthStatusTitle: ml ? 'ഇന്നത്തെ NM ഹാജർ നില' : "Today's NM present status",
    strengthStatusSubtitle: ml
      ? 'ഏത് ക്ലാസുകൾ അപ്‌ഡേറ്റ് ചെയ്തു / ബാക്കിയുണ്ട് — അദ്ധ്യാപകരുമായി പങ്കിടാൻ'
      : 'Which classes are updated or pending — share with teachers',
    strengthStatusCompact: ml ? '{updated}/{total} ക്ലാസ് അപ്‌ഡേറ്റ് ചെയ്തു' : '{updated} of {total} classes updated',
    strengthStatusAllDone: ml ? 'എല്ലാ {count} ക്ലാസുകളും ഇന്ന് അപ്‌ഡേറ്റ് ചെയ്തു' : 'All {count} classes updated for today',
    strengthStatusShowDetails: ml ? 'വിശദാംശം' : 'Details',
    strengthStatusHideDetails: ml ? 'മറയ്ക്കുക' : 'Hide',
    strengthStatusShowUpdated: ml ? '{count} അപ്‌ഡേറ്റ് ചെയ്തവ കാണുക' : 'Show {count} updated',
    strengthStatusHideUpdated: ml ? 'അപ്‌ഡേറ്റ് ചെയ്തവ മറയ്ക്കുക' : 'Hide updated',
    strengthStatusWhatsAppShort: ml ? 'WhatsApp' : 'WhatsApp',
    strengthStatusSharePending: ml ? 'ബാക്കിയുള്ളവ WhatsApp' : 'Share pending on WhatsApp',
    strengthStatusMdmsWarning: ml
      ? '10:30 AM — {count} ക്ലാസ് അപ്‌ഡേറ്റ് ചെയ്തിട്ടില്ല. 11 AM-ന് മുമ്പ് അപ്‌ഡേറ്റ് ചെയ്യുക.'
      : '10:30 AM — {count} class(es) not updated yet. Please update before 11 AM.',
    strengthStatusMdmsFinal: ml
      ? '11 AM — {count} ക്ലാസിൽ ഇന്നത്തെ NM ഹാജർ ഇല്ല!'
      : "11 AM — {count} class(es) still missing today's NM present!",
    teacherMdmsWarningOne: ml
      ? '11 AM-ന് മുമ്പ് {division} ഇന്നത്തെ NM ഹാജർ സമർപ്പിക്കുക.'
      : "Please submit today's NM present for {division} before 11 AM.",
    teacherMdmsWarningMany: ml
      ? '11 AM-ന് മുമ്പ് {count} ക്ലാസുകളിൽ NM ഹാജർ സമർപ്പിക്കുക.'
      : "Please submit today's NM present for {count} classes before 11 AM.",
    teacherMdmsFinalOne: ml
      ? '{division} — ഇന്നത്തെ NM ഹാജർ ഇനിയും സമർപ്പിച്ചിട്ടില്ല. ഇപ്പോൾ അപ്‌ഡേറ്റ് ചെയ്യുക.'
      : "You have not submitted today's NM present for {division}. Please update now.",
    teacherMdmsFinalMany: ml
      ? 'ഇന്നത്തെ NM ഹാജർ സമർപ്പിക്കാത്ത ക്ലാസുകൾ: {classes}'
      : "Please submit today's NM present for: {classes}",
    strengthStatusUpdatedCount: ml ? 'അപ്‌ഡേറ്റ് ചെയ്തു' : 'Updated',
    strengthStatusPendingCount: ml ? 'ബാക്കി' : 'Pending',
    strengthStatusProgress: ml ? 'പുരോഗതി' : 'Progress',
    strengthStatusPendingList: ml ? 'അപ്‌ഡേറ്റ് ബാക്കി' : 'Pending updates',
    strengthStatusUpdatedList: ml ? 'അപ്‌ഡേറ്റ് ചെയ്ത ക്ലാസുകൾ' : 'Updated classes',
    notAssigned: ml ? 'നിയോഗിച്ചിട്ടില്ല' : 'Not assigned',
    schoolsViewAll: ml ? 'എല്ലാ സ്കൂളുകളും' : 'All schools',
    renewalsTitle: ml ? 'പുതുക്കലുകൾ' : 'Renewals',
    renewalsSubtitle: ml
      ? 'കാലാവധി കഴിഞ്ഞതോ 30 ദിവസത്തിനുള്ളിൽ അവസാനിക്കുന്നതോ ആയ സ്കൂളുകൾ'
      : 'Schools expired or expiring within 30 days',
    renewalsFilterAll: ml ? 'എല്ലാ renewals' : 'All renewals',
    renewalsFilter14: ml ? '14 ദിവസം' : 'Next 14 days',
    renewalsWhatsApp: ml ? 'WhatsApp' : 'WhatsApp',
    renewalsMarkPaid: ml ? 'പണം കിട്ടി' : 'Mark paid',
    renewalsEmpty: ml ? 'renewals ഒന്നുമില്ല' : 'No renewals due',
    renewalsEmptyHint: ml ? '30 ദിവസത്തിനുള്ളിൽ അവസാനിക്കുന്ന സ്കൂളുകൾ ഇവിടെ കാണും' : 'Schools expiring within 30 days appear here',
    appUpdateTitle: ml ? 'പുതിയ പതിപ്പ് ലഭ്യം' : 'Update available',
    appUpdateWebBody: ml ? 'NMhelper-ന്റെ പുതിയ പതിപ്പ് ലഭ്യമാണ്. റിഫ്രഷ് ചെയ്ത് അപ്‌ഡേറ്റ് ചെയ്യുക.' : 'A newer NMhelper version is available. Refresh to load it.',
    appUpdateAndroidBody: ml ? 'Play Store-ൽ പുതിയ പതിപ്പ് ലഭ്യമാണ്.' : 'A newer version is on Google Play.',
    appUpdatePlayStore: ml ? 'Play Store-ൽ അപ്‌ഡേറ്റ്' : 'Update on Play Store',
    appUpdateInstalledVersion: ml ? 'ഇൻസ്റ്റാൾ ചെയ്തത്: v{v}' : 'Installed: v{v}',
    appUpdateRefresh: ml ? 'ഇപ്പോൾ അപ്‌ഡേറ്റ്' : 'Update now',
    appUpdateHardRefresh: ml ? 'ഹാർഡ് റിഫ്രഷ്' : 'Hard refresh',
    appUpdateDismiss: ml ? 'പിന്നീട്' : 'Later',
    storageBlocked: ml
      ? 'ഈ ബ്രൗസർ സംഭരണം തടഞ്ഞിരിക്കുന്നു (Private mode?). Safari/Chrome-ൽ Private മോഡ് ഓഫ് ചെയ്ത് വീണ്ടും ശ്രമിക്കുക.'
      : 'This browser is blocking storage (Private mode?). Turn off Private/Incognito and try again.',
    search: ml ? 'തിരയുക' : 'Search',
    filter: ml ? 'ഫിൽട്ടർ' : 'Filter',
    clearFilters: ml ? 'ഫിൽട്ടർ മായ്ക്കുക' : 'Clear filters',
    filterValidFrom: ml ? 'അവസാനം — മുതൽ' : 'Valid until — from',
    filterValidTo: ml ? 'അവസാനം — വരെ' : 'Valid until — to',
    filterValidExact: ml ? 'കൃത്യമായ തീയതി' : 'Exact expiry date',
    filterValidAnyDate: ml ? 'എല്ലാ തീയതികളും' : 'Any date',
    filterValidPresetAll: ml ? 'എല്ലാം' : 'All',
    filterValidPresetExpired: ml ? 'കാലാവധി കഴിഞ്ഞു' : 'Expired',
    filterValidPreset30: ml ? '30 ദിവസം' : 'Next 30 days',
    filterValidPreset14: ml ? '14 ദിവസം' : 'Next 14 days',
    filterDivisionsSort: ml ? 'ഡിവിഷനുകൾ' : 'Divisions',
    filterDivisionsDefault: ml ? 'ഡിഫോൾട്ട്' : 'Default',
    filterDivisionsHigh: ml ? 'കൂടുതൽ → കുറവ്' : 'High → low',
    filterDivisionsLow: ml ? 'കുറവ് → കൂടുതൽ' : 'Low → high',
    filterSchoolsCount: ml ? '{shown} / {total} സ്കൂളുകൾ' : '{shown} of {total} schools',
    searchNoResults: ml ? 'ഒന്നും കണ്ടെത്തിയില്ല' : 'No matches found',
    confirmDelete: ml ? 'ഇല്ലാതാക്കണമോ?' : 'Delete this item?',
    save: ml ? 'സേവ്' : 'Save',
    toastHeadAdded: ml ? 'സ്കൂൾ ഹെഡ് ചേർത്തു' : 'School head added',
    toastHeadRemoved: ml ? 'സ്കൂൾ ഹെഡ് നീക്കം ചെയ്തു' : 'School head removed',
    toastHeadPaused: ml ? 'ഹെഡ് താൽക്കാലികം നിർത്തി' : 'Head paused',
    toastHeadResumed: ml ? 'ഹെഡ് തുടർന്നു' : 'Head resumed',
    toastDivisionsSaved: ml ? 'ഡിവിഷനുകൾ സേവ് ചെയ്തു' : 'Divisions saved',
    toastTeacherAdded: ml ? 'അദ്ധ്യാപകനെ ചേർത്തു' : 'Teacher added',
    toastTeacherRemoved: ml ? 'അദ്ധ്യാപകനെ നീക്കം ചെയ്തു' : 'Teacher removed',
    toastClassAdded: ml ? 'ക്ലാസ് ചേർത്തു' : 'Class added',
    toastClassRemoved: ml ? 'ക്ലാസ് നീക്കം ചെയ്തു' : 'Class removed',
    toastCapacityUpdated: ml ? 'പരമാവധി അപ്‌ഡേറ്റ് ചെയ്തു' : 'Class limits updated',
    toastBoysCapExceeded: ml ? 'ആൺകുട്ടികളുടെ എണ്ണം പരമാവധിയിൽ കൂടുതലാണ്' : 'Boys count exceeds the class limit',
    toastGirlsCapExceeded: ml ? 'പെൺകുട്ടികളുടെ എണ്ണം പരമാവധിയിൽ കൂടുതലാണ്' : 'Girls count exceeds the class limit',
    toastHistoryDeleted: ml ? 'ചരിത്ര എൻട്രി നീക്കം ചെയ്തു' : 'History entry deleted',
    toastStrengthSaved: ml ? 'NM ഹാജർ സേവ് ചെയ്തു' : 'NM present saved',
    toastNutritionSaved: ml ? 'പോഷകാഹാര എണ്ണം സേവ് ചെയ്തു' : 'Nutrition count saved',
    toastInvalidNutritionCount: ml ? 'ശരിയായ എണ്ണം നൽകുക' : 'Please enter a valid count',
    toastNutritionEnterCount: ml
      ? 'ഓരോ ഇനത്തിനും ആൺ, പെൺ എണ്ണം രണ്ടും നൽകുക'
      : 'Enter both boys and girls for each item',
    navNutrition: ml ? 'പോഷകാഹാരം' : 'Nutrition',
    moreNutritionDesc: ml
      ? 'മുട്ട, വാഴപ്പഴം, പാൽ — ദിവസേനയല്ലാത്ത എണ്ണം'
      : 'Egg, banana, milk — counts for days they are served',
    nutritionTitle: ml ? 'പോഷകാഹാരം' : 'Nutrition',
    nutritionSubtitle: ml
      ? 'ഇന്ന് എന്താണ് നൽകിയത്? ടോഗിൾ ഓൺ ചെയ്ത് എണ്ണം നൽകുക'
      : 'What was served today? Turn on a toggle and enter counts',
    nutritionToggleEggBanana: ml ? 'മുട്ട & വാഴപ്പഴം' : 'Egg & Banana',
    nutritionToggleMilk: ml ? 'പാൽ' : 'Milk',
    nutritionEggBananaSection: ml ? 'മുട്ട & വാഴപ്പഴം' : 'Egg & Banana',
    nutritionMilkSection: ml ? 'പാൽ' : 'Milk',
    nutritionEgg: ml ? 'മുട്ട' : 'Egg',
    nutritionBanana: ml ? 'വാഴപ്പഴം' : 'Banana',
    nutritionMilk: ml ? 'പാൽ' : 'Milk',
    nutritionCount: ml ? 'എണ്ണം' : 'Count',
    nutritionNoData: ml ? 'ഈ ദിവസം പോഷകാഹാര ഡാറ്റയില്ല' : 'No nutrition data for this day',
    nutritionNoHistory: ml ? 'പോഷകാഹാര ചരിത്രം ഇല്ല' : 'No nutrition history yet',
    nutritionDatesHighlightHint: ml
      ? 'നീല നിറമുള്ള തീയതികളിൽ മാത്രം ഡാറ്റ ഉണ്ട് — അവ തിരഞ്ഞെടുക്കുക'
      : 'Highlighted dates have nutrition data — pick one to view',
    nutritionTodayOnlyHint: ml
      ? 'ഇന്നത്തെ ഡാറ്റ കാണുന്നു. മുൻ ദിവസങ്ങൾ ടീച്ചർമാർ സേവ് ചെയ്ത ശേഷം കലണ്ടറിൽ വരും.'
      : 'Showing today’s data. More dates appear on the calendar after teachers save.',
    nutritionHistoryDatesTitle: ml ? 'അപ്‌ഡേറ്റ് ചെയ്ത തീയതികൾ' : 'Dates with updates',
    nutritionToggleHint: ml
      ? 'ഇന്ന് നൽകിയ ഇനം ടോഗിൾ ഓൺ ചെയ്ത് എണ്ണം നൽകുക'
      : 'Turn on what was served today, then enter counts',
    nutritionSaveHint: ml
      ? 'സേവ് ചെയ്യാൻ ആൺ, പെൺ എണ്ണം രണ്ടും നൽകുക'
      : 'Enter both boys and girls, then save that item',
    nutritionClearTitle: ml ? 'നീക്കം ചെയ്യുക?' : 'Remove entry?',
    nutritionClearEggBanana: ml
      ? 'ഇന്നത്തെ മുട്ട/വാഴപ്പഴം എണ്ണം നീക്കം ചെയ്യണോ?'
      : "Remove today's egg and banana counts?",
    nutritionClearMilk: ml
      ? 'ഇന്നത്തെ പാൽ എണ്ണം നീക്കം ചെയ്യണോ?'
      : "Remove today's milk count?",
    historyModeNm: ml ? 'NM ഹാജർ' : 'NM present',
    historyModeNutrition: ml ? 'പോഷകാഹാരം' : 'Nutrition',
    saved: ml ? 'സേവ് ചെയ്തു' : 'Saved',
    toastClassAssigned: ml ? 'ക്ലാസ് നിയോഗിച്ചു' : 'Class assigned',
    toastClassUnassigned: ml ? 'ക്ലാസ് നീക്കി' : 'Class unassigned',
    changeClass: ml ? 'ക്ലാസുകൾ' : 'Classes',
    assignClassTitle: ml ? 'ക്ലാസ് നിയോഗിക്കുക' : 'Assign classes',
    addAnotherClass: ml ? 'മറ്റൊരു ക്ലാസ് ചേർക്കുക' : 'Add another class',
    currentClasses: ml ? 'നിലവിലെ ക്ലാസുകൾ' : 'Current classes',
    removeClass: ml ? 'നീക്കുക' : 'Remove',
    teacherSwitchClassTitle: ml ? 'ക്ലാസ് തിരഞ്ഞെടുക്കുക' : 'Choose class',
    teacherSwitchClassSubtitle: ml
      ? 'NM ഹാജർ നൽകാൻ ക്ലാസ് തിരഞ്ഞെടുക്കുക'
      : 'Pick which class you are entering NM present for',
    activeClass: ml ? 'സജീവം' : 'Active',
    noClassOption: ml ? '(ക്ലാസ് ഇല്ല)' : '(No class)',
    classTakenBy: ml ? '{class} — {name}' : '{class} — {name}',
    replaceTeacherTitle: ml ? 'അദ്ധ്യാപകനെ മാറ്റണോ?' : 'Replace teacher?',
    replaceTeacherConfirm: ml
      ? '{class} ഇപ്പോൾ {name} നിയോഗിച്ചിട്ടുണ്ട്. മാറ്റണോ?'
      : '{class} is assigned to {name}. Replace them?',
    replaceTeacherBtn: ml ? 'മാറ്റുക' : 'Replace',
    headSettingsTitle: ml ? 'ഹെഡ് ഓവർവ്യൂ' : 'Head overview',
    headSettingsSubtitle: ml ? 'നിങ്ങളുടെ സ്കൂൾ സംഗ്രഹം' : 'Your school at a glance',
    teacherSettingsTitle: ml ? 'അദ്ധ്യാപക ഓവർവ്യൂ' : 'Teacher overview',
    teacherSettingsSubtitle: ml ? 'ക്ലാസും ആപ്പ് സ്റ്റാറ്റസും' : 'Your class and app status',
    divisionLimitHint: ml ? 'അഡ്മിൻ നൽകിയ പരമാവധി' : 'Limit set by admin',
    unassignedClasses: ml ? 'അനിയോഗിത ക്ലാസുകൾ' : 'Unassigned classes',
    refreshData: ml ? 'ഡാറ്റ റിഫ്രഷ്' : 'Refresh data',
    headTipsTitle: ml ? 'സഹായം' : 'Tips',
    headTipAssign: ml
      ? 'അദ്ധ്യാപകർ → Classes: ഒരേ അദ്ധ്യാപകനെ ഒന്നിലധികം ക്ലാസുകളിലേക്ക് നിയോഗിക്കാം (ഓരോ ക്ലാസിലും ഒരു അദ്ധ്യാപകൻ).'
      : 'Teachers → Classes: assign one teacher to multiple classes (one teacher per class).',
    headTipClasses: ml ? 'ക്ലാസുകൾ ചേർക്കുക, പരമാവധി വിദ്യാർത്ഥികൾ എഡിറ്റ് ചെയ്യുക.' : 'Add classes and edit max students on the Classes tab.',
    headTipReport: ml ? 'റിപ്പോർട്ട് ടാബിൽ ഇന്നത്തെ NM ഹാജർ കാണുക, എക്സ്പോർട്ട് ചെയ്യുക.' : 'View and export today’s NM present on the Report tab.',
    teacherTipsTitle: ml ? 'സഹായം' : 'Tips',
    teacherTipDaily: ml ? 'ഹോം ടാബിൽ ദൈനംദിന ആൺ/പെൺ എണ്ണം നൽകി NM ഹാജർ സേവ് ചെയ്യുക.' : 'Enter daily boys/girls on Home and save NM present.',
    teacherTipOffline: ml ? 'ഇന്റർനെറ്റ് ഇല്ലാതെയും സേവ് ചെയ്യാം; പിന്നീട് സമന്വയിക്കും.' : 'You can save offline; data syncs when back online.',
    deviceNetwork: ml ? 'ഈ ഉപകരണം' : 'This device',
    pendingSyncCount: ml ? '{n} മാറ്റങ്ങൾ സമന്വയിക്കാൻ കാത്തിരിക്കുന്നു' : '{n} change(s) waiting to sync',
    teacherLoggedInAs: ml ? 'ലോഗിൻ:' : 'Signed in as',
    more: ml ? 'കൂടുതൽ' : 'More',
    moreMenuSubtitle: ml ? 'ചരിത്രം, സെറ്റിംഗ്സ്, അക്കൗണ്ട്' : 'History, settings, and account',
    moreHistoryDesc: ml ? 'മുൻ ദിവസങ്ങളുടെ റിപ്പോർട്ട്' : 'Past daily reports',
    teacherHistoryHighlightHint: ml
      ? 'നിങ്ങളുടെ ക്ലാസ്(കൾ) ഹൈലൈറ്റ് ചെയ്തിരിക്കുന്നു. എക്സ്പോർട്ടിൽ ഹൈലൈറ്റ് ഉണ്ടാകില്ല.'
      : 'Your class(es) are highlighted. Exports do not include highlighting.',
    moreSettingsDesc: ml ? 'ഓവർവ്യൂ, ഭാഷ, സ്റ്റാറ്റസ്' : 'Overview, language, status',
    moreAccountDesc: ml ? 'പാസ്‌വേഡ് മാറ്റുക' : 'Change password',
    back: ml ? 'പിന്നോട്ട്' : 'Back',
    signedInAs: ml ? 'ലോഗിൻ' : 'Signed in as',
    langMalayalam: ml ? 'മലയാളം' : 'Malayalam',
    langEnglish: ml ? 'ഇംഗ്ലീഷ്' : 'English',
    refreshStatusHint: ml ? 'API നില പരിശോധിക്കുക' : 'Check API connection',
    tapToRefresh: ml ? 'റിഫ്രഷ്' : 'Refresh',
    refreshDataHint: ml ? 'ക്ലാസുകളും അദ്ധ്യാപകരും' : 'Classes and teachers',
    appearance: ml ? 'രൂപം' : 'Appearance',
    appearanceHint: ml ? 'ലൈറ്റ്, ഡാർക്ക് അല്ലെങ്കിൽ സിസ്റ്റം' : 'Light, dark, or follow system',
    themeLight: ml ? 'ലൈറ്റ്' : 'Light',
    themeDark: ml ? 'ഡാർക്ക്' : 'Dark',
    themeSystem: ml ? 'സിസ്റ്റം' : 'System',
    themeSwitchHint: ml
      ? 'ക്ലിക്ക്: ലൈറ്റ്/ഡാർക്ക്. ഡബിൾ ക്ലിക്ക്: സിസ്റ്റം'
      : 'Click: light or dark. Double-click: use system theme',
    subscriptionValidUntil: ml ? 'സബ്സ്ക്രിപ്ഷൻ അവസാനം' : 'Valid until',
    subscriptionExpiresHint: ml
      ? 'അക്കാദമിക വർഷം: ഏപ്രിൽ – മാർച്ച് 31. കാലാവധി മാറ്റാം.'
      : 'Academic year: April – March 31. You can change the end date.',
    subscriptionExpired: ml ? 'കാലാവധി കഴിഞ്ഞു' : 'Expired',
    subscriptionExpiringSoon: ml ? 'ഉടൻ കാലാവധി' : 'Expiring soon',
    subscriptionExpiringTitle: ml ? 'പ്ലാൻ കാലാവധി അവസാനിക്കുന്നു' : 'Your plan is expiring',
    subscriptionExpiringMessage: ml
      ? 'നിങ്ങളുടെ പ്ലാൻ {date} ന് അവസാനിക്കുന്നു ({days} ദിവസം ബാക്കി). പുതുക്കാൻ അഡ്മിനുമായി ബന്ധപ്പെട്ട് പേയ്മെന്റ് നടത്തുക.'
      : 'Your plan expires on {date} ({days} days left). Contact your admin to renew and pay.',
    subscriptionExpiringUrgentTitle: ml ? 'പ്ലാൻ ഉടൻ അവസാനിക്കും' : 'Plan expires very soon',
    subscriptionExpiringUrgentMessage: ml
      ? 'പ്ലാൻ {date} ന് അവസാനിക്കുന്നു — ഇനി {days} ദിവസം മാത്രം. ഇപ്പോൾ തന്നെ അഡ്മിനുമായി ബന്ധപ്പെട്ട് പേയ്മെന്റ് നടത്തുക.'
      : 'Your plan ends on {date} — only {days} days left. Contact your admin now to renew and pay.',
    subscriptionExpiredTitle: ml ? 'പ്ലാൻ കാലാവധി കഴിഞ്ഞു' : 'Plan expired',
    subscriptionExpiredMessage: ml
      ? 'പ്ലാൻ {date} ന് അവസാനിച്ചു. തുടരാൻ അഡ്മിനുമായി ബന്ധപ്പെട്ട് പേയ്മെന്റ് നടത്തുക.'
      : 'Your plan ended on {date}. Contact your admin to renew and pay to continue.',
    subscriptionExpiringTeacherNote: ml
      ? 'ഇത് നിങ്ങളുടെ സ്കൂളിന്റെ സബ്സ്ക്രിപ്ഷനാണ് — സ്കൂൾ ഹെഡിനോട് അഡ്മിനെ ബന്ധപ്പെടാൻ പറയുക.'
      : 'This is your school’s subscription — ask your school head to contact the admin.',
    subscriptionWritesBlocked: ml
      ? 'പ്ലാൻ കാലാവധി കഴിഞ്ഞു. തുടരാൻ അഡ്മിനുമായി ബന്ധപ്പെട്ട് പേയ്മെന്റ് നടത്തുക.'
      : 'Plan expired. Contact your admin to renew and pay before using this feature.',
    pricingModelHint: ml
      ? 'വില: ക്ലാസിന് ₹50/വർഷം. പുതിയ സ്കൂൾ: 1 മാസം ട്രയൽ (താഴെ തീയതി). പണം കിട്ടിയാൽ “Paid year” ക്ലിക്ക് ചെയ്യുക.'
      : 'Price: ₹50 per class per year. New schools: 1-month trial (date below). After payment, tap “Paid year”.',
    setTrialMonth: ml ? '1 മാസം ട്രയൽ' : '1-month trial',
    setPaidYear: ml ? 'പണം കിട്ടി (വർഷം)' : 'Paid year',
    estimatedYearlyFee: ml ? 'ആനുകാലിക ഫീസ് (₹50 × ക്ലാസ്)' : 'Est. yearly fee (₹50 × classes)',
    generateInvoice: ml ? 'ഇൻവോയ്സ്' : 'Invoice',
    bulkGenerateInvoices: ml ? 'ഇൻവോയ്സുകൾ' : 'Generate invoices',
    bulkInvoiceTitle: ml ? 'ബൾക്ക് ഇൻവോയ്സ്' : 'Generate invoices',
    bulkInvoiceSchools: ml ? 'തിരഞ്ഞെടുത്ത സ്കൂളുകൾ' : 'Selected schools',
    bulkInvoiceGrandTotal: ml ? 'ആകെ (എല്ലാ സ്കൂളുകൾ)' : 'Grand total (all schools)',
    bulkInvoicePeriodHint: ml
      ? 'എല്ലാ ഇൻവോയ്സുകളിലും ഒരേ സേവന കാലയളവ് — ആവശ്യമെങ്കിൽ തിരുത്തുക.'
      : 'Same service period on every invoice — edit start and end if needed.',
    bulkInvoiceDownloadZip: ml ? 'ZIP ഡൗൺലോഡ്' : 'Download ZIP',
    invoiceIssuerSection: ml ? 'ഇഷ്യൂവർ (നിങ്ങൾ)' : 'Issuer (you)',
    invoiceIssuerDetailsTitle: ml ? 'ഇൻവോയ്സ് ഇഷ്യൂവർ' : 'Invoice issuer details',
    invoiceIssuerDetailsHint: ml
      ? 'സെർവറിൽ സേവ് ചെയ്യുന്നു — ഏത് ബ്രൗസറിലും അഡ്മിൻ ലോഗിൻ ചെയ്താൽ ഒരേ വിവരങ്ങൾ.'
      : 'Saved on the server — same details on any device when logged in as admin.',
    invoiceIssuerName: ml ? 'പേര്' : 'Name',
    invoiceIssuerAddress: ml ? 'വിലാസം' : 'Address',
    invoiceIssuerEmail: ml ? 'ഇമെയിൽ' : 'Email',
    invoiceIssuerEmail2: ml ? 'ഇമെയിൽ 2 (ഓപ്ഷണൽ)' : 'Email 2 (optional)',
    invoiceIssuerPhone: ml ? 'ഫോൺ' : 'Phone',
    invoiceUpiId: ml ? 'UPI ID' : 'UPI ID',
    invoiceBankDetails: ml ? 'ബാങ്ക് വിവരങ്ങൾ (ഓപ്ഷണൽ)' : 'Bank details (optional)',
    invoiceRatePerClass: ml ? 'ക്ലാസിന് വാർഷിക നിരക്ക് (₹)' : 'Rate per class per year (₹)',
    invoiceLineDescription: ml ? 'ലൈൻ വിവരണം' : 'Line item description',
    invoicePaymentTerms: ml ? 'പേയ്മെന്റ് നിബന്ധനകൾ' : 'Payment terms',
    invoiceFooterNote: ml ? 'ഫൂട്ടർ കുറിപ്പ്' : 'Footer note',
    invoiceLineItem: ml ? 'ഇൻവോയ്സ് ഇനം' : 'Invoice line item',
    invoicePeriod: ml ? 'സേവന കാലയളവ്' : 'Service period',
    invoiceDate: ml ? 'ഇൻവോയ്സ് തീയതി' : 'Invoice date',
    invoicePeriodStart: ml ? 'ആരംഭം' : 'Period start',
    invoicePeriodEnd: ml ? 'അവസാനം' : 'Period end',
    invoiceTotal: ml ? 'ആകെ' : 'Total',
    invoiceDownloadPdf: ml ? 'PDF ഡൗൺലോഡ്' : 'Download PDF',
    invoiceSaveAsDefault: ml ? 'ഡിഫോൾട്ട് ഇഷ്യൂവറായി സേവ് ചെയ്യുക' : 'Save as default issuer',
    invoiceNoDivisions: ml ? 'ക്ലാസ് എണ്ണം 0 — ഇൻവോയ്സ് സൃഷ്ടിക്കാൻ കഴിയില്ല' : 'Class count is 0 — cannot generate invoice',
    invoiceSelectSchools: ml ? 'സ്കൂളുകൾ തിരഞ്ഞെടുക്കുക' : 'Select schools',
    invoiceResetIssuer: ml ? 'ഡിഫോൾട്ടിലേക്ക്' : 'Reset to defaults',
    toastInvoiceIssuerSaved: ml ? 'ഇൻവോയ്സ് ഇഷ്യൂവർ സേവ് ചെയ്തു' : 'Invoice issuer details saved',
    toastInvoicesZipDone: ml ? 'ഇൻവോയ്സ് ZIP ഡൗൺലോഡ് ചെയ്തു' : 'Invoice ZIP downloaded',
    toastInvoiceSkippedNoDivisions: ml ? '0 ക്ലാസ് — ഒഴിവാക്കി' : 'Skipped schools with 0 classes',
    editHeadSettings: ml ? 'സ്കൂൾ ഹെഡ് എഡിറ്റ്' : 'Edit school head',
    toastSubscriptionSaved: ml ? 'സബ്സ്ക്രിപ്ഷൻ തീയതി സേവ് ചെയ്തു' : 'Subscription end date saved',
    testerSignupsTitle: ml ? 'ടെസ്റ്റർ സൈൻഅപ്പ് ഇമെയിലുകൾ' : 'Tester signup emails',
    testerSignupsSubtitle: ml
      ? 'tester.nmhelper.in ൽ നിന്ന് വന്ന ഇമെയിലുകൾ'
      : 'Emails submitted from tester.nmhelper.in',
    copyEmails: ml ? 'ഇമെയിൽ കോപ്പി' : 'Copy emails',
    downloadCSV: ml ? 'CSV ഡൗൺലോഡ്' : 'Download CSV',
    testerEmail: ml ? 'ടെസ്റ്റർ ഇമെയിൽ' : 'Tester email',
    consent: ml ? 'സമ്മതി' : 'Consent',
    futureApps: ml ? 'ഭാവിയിലെ ആപ്പുകൾ' : 'Future apps',
    submittedAt: ml ? 'സമർപ്പിച്ച സമയം' : 'Submitted at',
    yes: ml ? 'അതെ' : 'Yes',
    no: ml ? 'ഇല്ല' : 'No',
    landingHeroBadge: ml ? 'കേരള സ്കൂളുകൾക്ക് · MDMS' : 'Kerala schools · MDMS',
    landingTitle: ml
      ? 'എല്ലാ ദിവസവും NM ഹാജർ രേഖപ്പെടുത്തുക'
      : 'Record NM present for MDMS every day',
    landingSubtitle: ml
      ? 'MDMS-ൽ നൽകുന്ന NM ഹാജർ: ക്ലാസിലെ ഹാജർ (ആൺ/പെൺ)യും ഇന്ന് നൽകിയ പോഷകാഹാര എണ്ണവും (മുട്ട, വാഴപ്പഴം, പാൽ). അദ്ധ്യാപകൻ ക്ലാസിൽ നിന്ന് രണ്ടും നൽകും. ഹെഡ് റിപ്പോർട്ട് കാണും, എക്സ്പോർട്ട് ചെയ്യും. വൈഫൈ പോയാലും സേവ് ചെയ്യാം.'
      : 'NM present is what schools submit on MDMS: present boys and girls per class, plus nutrition counts when egg, banana, or milk was served. Teachers enter both from class. Heads open reports and export. Still saves offline.',
    landingMetaDescription: ml
      ? 'NMhelper: കേരള സ്കൂളുകളിൽ MDMS NM ഹാജർ, പോഷകാഹാര (മുട്ട/വാഴപ്പഴം/പാൽ) ആൺ/പെൺ എണ്ണം, റിപ്പോർട്ട്, CSV/ODS. Google Play + app.nmhelper.in'
      : 'NMhelper for Kerala schools: daily NM present and MDMS nutrition counts (egg, banana, milk) with boys/girls per class. Reports, history, CSV/ODS export. Google Play or app.nmhelper.in.',
    landingLoginCta: ml ? 'സൈൻ ഇൻ' : 'Sign in',
    landingAndroidCta: ml ? 'Google Play-യിൽ' : 'Get it on Google Play',
    landingAndroidStoreEyebrow: ml ? 'ലഭ്യമാണ്' : 'Get it on',
    landingAndroidStoreName: ml ? 'Google Play' : 'Google Play',
    landingPwaCta: ml ? 'വെബിൽ തുറക്കുക' : 'Open on web',
    landingAndroidUrl: 'https://play.google.com/store/apps/details?id=in.nmhelper.app',
    landingNavFeatures: ml ? 'സവിശേഷതകൾ' : 'Features',
    landingNavHow: ml ? 'എങ്ങനെ' : 'How it works',
    landingNavFaq: ml ? 'FAQ' : 'FAQ',
    landingChipOffline: ml ? 'ഓഫ്‌ലൈൻ' : 'Works offline',
    landingChipBilingual: ml ? 'EN / ML' : 'English & Malayalam',
    landingChipFree: ml ? 'ക്ലാസ് അനുസരിച്ച് നിരക്ക്' : 'Per-class pricing',
    landingChipMdms: ml ? 'MDMS-ന് തയ്യാർ' : 'MDMS ready',
    landingMockTitle: ml ? 'ഇന്നത്തെ NM റിപ്പോർട്ട്' : "Today's NM report",
    landingMockSubtitle: ml ? 'ക്ലാസ് പ്രകാരം ഹാജർ (ഉദാഹരണം)' : 'Present by class (example)',
    landingMockClass: ml ? 'ക്ലാസ്' : 'Class',
    landingMockBoys: ml ? 'ആൺ' : 'Boys',
    landingMockGirls: ml ? 'പെൺ' : 'Girls',
    landingMockTotal: ml ? 'ആകെ' : 'Total',
    landingFeaturesTitle: ml ? 'എന്തിനാണ് ഉപയോഗിക്കുന്നത്' : 'What you use it for',
    landingFeaturesSubtitle: ml
      ? 'MDMS-ന് വേണ്ടിയുള്ള NM ഹാജർ. ഹാജറും പോഷകാഹാര എണ്ണവും ഒരേ ആപ്പിൽ.'
      : 'NM present for MDMS. Present and nutrition counts in one app, same boys/girls fields.',
    landingFeature1Title: ml ? 'NM ഹാജർ' : 'NM present',
    landingFeature1Body: ml
      ? 'ഓരോ ക്ലാസിനും ആൺ, പെൺ ഹാജർ. അതേ സ്ക്രീനിൽ ഇന്ന് നൽകിയ മുട്ട/വാഴപ്പഴം/പാലിന്റെ പോഷകാഹാര എണ്ണവും. MDMS-ന് നൽകുന്ന രീതിയിൽ.'
      : 'Boys and girls present per class. On the same screen, nutrition counts for egg, banana, or milk when served. Same fields as MDMS expects.',
    landingFeature2Title: ml ? 'റിപ്പോർട്ട്' : 'Reports',
    landingFeature2Body: ml
      ? 'NM ഹാജർ റിപ്പോർട്ട്, പോഷകാഹാര റിപ്പോർട്ട്, മാസ പട്ടിക. CSV, ODS, DOC എക്സ്പോർട്ട്.'
      : 'NM present report, nutrition report, month table. Export CSV, ODS, or DOC for MDMS or the block office.',
    landingFeature3Title: ml ? 'ഓഫ്‌ലൈൻ' : 'Offline',
    landingFeature3Body: ml
      ? 'ക്ലാസിൽ സിഗ്നൽ ഇല്ല? സേവ് ചെയ്യൂ. ഡാറ്റ വന്നാൽ അപ്‌ലോഡ് ആകും.'
      : 'No signal in the classroom? Save anyway. It uploads when the phone gets data again.',
    landingFeature4Title: ml ? 'രണ്ട് ഭാഷ' : 'Two languages',
    landingFeature4Body: ml
      ? 'മെനുവിൽ ഇംഗ്ലീഷും മലയാളവും മാറ്റാം.'
      : 'Flip between English and Malayalam from the menu.',
    landingFeature5Title: ml ? 'പേരുകൾ സംഭരിക്കില്ല' : 'No student names',
    landingFeature5Body: ml
      ? 'ഓരോ ദിവസവും ക്ലാസിന്റെ ആകെ ആൺ/പെൺ എണ്ണം മാത്രം. പേരോ ഫോട്ടോയോ ഇല്ല.'
      : 'Only the total boys and girls for each class on each day. No names, no photos.',
    landingFeature6Title: ml ? 'ഫോൺ അല്ലെങ്കിൽ ബ്രൗസർ' : 'Phone or browser',
    landingFeature6Body: ml
      ? 'Google Play-ൽ ഇൻസ്റ്റാൾ ചെയ്യുക, അല്ലെങ്കിൽ വെബ് ആപ്പ് ഹോം സ്ക്രീനിൽ ചേർക്കുക.'
      : 'Install from Google Play, or use the web app and add it to your home screen.',
    landingRolesTitle: ml ? 'ഹെഡും ടീച്ചറും' : 'Head and teacher',
    landingRolesSubtitle: ml
      ? 'വെവ്വേറെ ലോഗിൻ, വെവ്വേറെ സ്ക്രീൻ. ഒരേ സ്കൂൾ ഡാറ്റ.'
      : 'Different logins, different screens. Same school data.',
    landingHeadRoleTitle: ml ? 'പ്രധാനാധ്യാപകൻ' : 'Head',
    landingHeadRoleBody: ml
      ? 'ക്ലാസുകൾ, അദ്ധ്യാപകർ, NM + പോഷകാഹാര റിപ്പോർട്ട്, ചരിത്രം, എക്സ്പോർട്ട്.'
      : 'Classes, teachers, NM and nutrition reports, history, export for MDMS.',
    landingTeacherRoleTitle: ml ? 'അദ്ധ്യാപകൻ' : 'Teacher',
    landingTeacherRoleBody: ml
      ? 'NM ഹാജർ നൽകുക. ഇന്ന് പോഷകാഹാരം നൽകിയെങ്കിൽ അതിന്റെ ആൺ/പെൺ എണ്ണവും. ഓഫ്‌ലൈൻ OK.'
      : 'Enter NM present. If nutrition was served today, enter those boys/girls counts too. Offline is fine.',
    landingHelpPdfBadge: ml ? 'ഉപയോഗ ഗൈഡ്' : 'User guide',
    landingHelpPdfTitle: ml ? 'NMhelper ഉപയോഗ ഗൈഡ് (PDF)' : 'NMhelper user guide (PDF)',
    landingHelpPdfBody: ml
      ? 'ഹെഡ്, ടീച്ചർ ഗൈഡ്: ലോഗിൻ, ക്ലാസ്, റിപ്പോർട്ട്, എക്സ്പോർട്ട്. സ്റ്റാഫിന് പ്രിന്റ് ചെയ്ത് കൊടുക്കാം.'
      : 'PDF walkthrough for heads and teachers: login, classes, reports, exports. Handy to print for staff.',
    landingHelpPdfCta: ml ? 'PDF ഡൗൺലോഡ്' : 'Download PDF',
    landingHelpPdfOnline: ml ? 'ഓൺലൈൻ ഗൈഡ്' : 'Online guide',
    landingHowTitle: ml ? 'എങ്ങനെ തുടങ്ങാം' : 'Getting started',
    landingStepOneLabel: ml ? '1' : '1',
    landingStepOneTitle: ml ? 'ആപ്പ് തുറക്കുക' : 'Open the app',
    landingStepOne: ml
      ? 'Google Play-ൽ നിന്ന് ഇൻസ്റ്റാൾ ചെയ്യുക, അല്ലെങ്കിൽ app.nmhelper.in തുറക്കുക.'
      : 'Get NMhelper from Google Play or open app.nmhelper.in.',
    landingStepTwoLabel: ml ? '2' : '2',
    landingStepTwoTitle: ml ? 'സൈൻ ഇൻ' : 'Sign in',
    landingStepTwo: ml
      ? 'ഹെഡ് അല്ലെങ്കിൽ ടീച്ചർ തിരഞ്ഞെടുത്ത് സ്കൂൾ നൽകിയ യൂസർനെയം ഉപയോഗിക്കുക.'
      : 'Pick head or teacher and log in with the username your school gave you.',
    landingStepThreeLabel: ml ? '3' : '3',
    landingStepThreeTitle: ml ? 'എണ്ണം നൽകുക' : 'Enter counts',
    landingStepThree: ml
      ? 'NM ഹാജർ സേവ് ചെയ്യുക. ഇന്ന് മുട്ട/വാഴപ്പഴം/പാൽ നൽകിയെങ്കിൽ പോഷകാഹാര എണ്ണവും അതേ സ്ക്രീനിൽ.'
      : 'Save NM present. If egg, banana, or milk was served, enter nutrition counts on the same screen.',
    landingFaqTitle: ml ? 'പതിവ് ചോദ്യങ്ങൾ' : 'Common questions',
    landingFaq1Q: ml ? 'ഇത് സൗജന്യമാണോ?' : 'Is NMhelper free?',
    landingFaq1A: ml
      ? 'ആപ്പ് ഡൗൺലോഡ് സൗജന്യം. പുതിയ സ്കൂളുകൾക്ക് ഒരു മാസം ട്രയൽ. പിന്നീട് ക്ലാസിന് വാർഷിക നിരക്ക്.'
      : 'Downloading the app is free. New schools get a trial month. After that you pay per class for the year.',
    landingFaq2Q: ml ? 'ആർക്ക് ഉപയോഗിക്കാം?' : 'Who is it for?',
    landingFaq2A: ml
      ? 'സ്കൂൾ ഹെഡും ക്ലാസ് ടീച്ചറും. രക്ഷിതാക്കൾക്കോ വിദ്യാർത്ഥികൾക്കോ അല്ല.'
      : 'School heads and classroom teachers. Not for parents or students.',
    landingFaq3Q: ml ? 'ഡാറ്റ സുരക്ഷിതമാണോ?' : 'Is my data safe?',
    landingFaq3A: ml
      ? 'എണ്ണം മാത്രം. പേരോ ആധാർഓ ഫോട്ടോയോ ഇല്ല. privacy.nmhelper.in-ൽ വിശദാംശം.'
      : 'We store counts only. No student names, Aadhaar, or photos. See privacy.nmhelper.in.',
    landingFaq4Q: ml ? 'ഓഫ്‌ലൈൻ പ്രവർത്തിക്കുമോ?' : 'Does it work offline?',
    landingFaq4A: ml
      ? 'അതെ. ക്ലാസിൽ സിഗ്നൽ ഇല്ലാതെ പലപ്പോഴും സേവ് ചെയ്യാം. പിന്നീട് സിങ്ക് ആകും.'
      : 'Yes. Teachers often have weak signal in class. Entries wait on the phone and sync later.',
    landingFaq5Q: ml ? 'എങ്ങനെ ഇൻസ്റ്റാൾ ചെയ്യാം?' : 'How do I install it?',
    landingFaq5A: ml
      ? 'ഈ പേജിലെ Google Play ലിങ്ക്, അല്ലെങ്കിൽ app.nmhelper.in-ൽ സൈൻ ഇൻ ചെയ്ത് Chrome-ൽ PWA ആയി ചേർക്കുക.'
      : 'Use the Google Play link on this page, or sign in at app.nmhelper.in and install from Chrome.',
    landingFaq6Q: ml ? 'പോഷകാഹാരം MDMS-ൽ എങ്ങനെ നൽകാം?' : 'How does nutrition fit MDMS?',
    landingFaq6A: ml
      ? 'MDMS-ന്റെ പോഷകാഹാര വിഭാഗത്തിന് വേണ്ടിയുള്ള ആൺ/പെൺ എണ്ണം. NM ഹാജർ പോലെ തന്നെ ക്ലാസിന് ആൺ/പെൺ. ഇന്ന് മുട്ട മാത്രം നൽകിയെങ്കിൽ മുട്ട മാത്രം നൽകുക.'
      : 'Nutrition is the boys/girls count MDMS asks for each item served. Same pattern as NM present. Egg only today? Enter egg only.',
    landingCtaBannerTitle: ml ? 'ട്രയൽ വേണോ?' : 'Want a trial for your school?',
    landingCtaBannerBody: ml
      ? 'വാട്സ്ആപ്പ് അല്ലെങ്കിൽ ഇമെയിൽ ചെയ്യുക. ഹെഡ് ലോഗിനും ക്ലാസ് ലിസ്റ്റും സെറ്റ് ചെയ്തു തരാം.'
      : 'Message us on WhatsApp or email. We will set up the head login and class list.',
    landingContactTitle: ml ? 'ചോദ്യമുണ്ടോ?' : 'Questions?',
    landingContactBody: ml
      ? 'ലോഗിൻ, പുതിയ സ്കൂൾ, ബില്ലിംഗ്: ഇമെയിൽ അല്ലെങ്കിൽ വാട്സ്ആപ്പ്. നിഷാൽ രണ്ടിലും മറുപടി നൽകും.'
      : 'Login trouble, new school setup, billing: email or WhatsApp. Nishal replies on both.',
    landingFooterTagline: ml
      ? 'കേരള സ്കൂളുകളിലെ MDMS NM ഹാജർ രജിസ്റ്റർ.'
      : 'MDMS NM present register for Kerala schools.',
    landingFooterRights: ml ? 'എല്ലാ അവകാശങ്ങളും നിക്ഷിപ്തം.' : 'All rights reserved.',
    landingFooterPrivacy: ml ? 'സ്വകാര്യത' : 'Privacy',
    landingFooterTerms: ml ? 'നിബന്ധനകൾ' : 'Terms',
    landingFooterHelp: ml ? 'സഹായം' : 'Help',
    landingFooterPdf: ml ? 'PDF ഗൈഡ്' : 'Guide PDF',
    landingFooterDeleteData: ml ? 'ഡാറ്റ ഇല്ലാതാക്കുക' : 'Delete my data',
    landingFooterTester: ml ? 'ടെസ്റ്റർ' : 'Tester site',
    landingFooterGithub: ml ? 'GitHub' : 'GitHub',
  };
}

